import { Injectable } from "@angular/core";

@Injectable()
export class DidoCoreOptions {
    local?: boolean
}